module.exports = __webpack_public_path__ + "static/media/toGoldImg.7bf77bc0.png";